import {
  OUTLETS_FETCH_ALL,
  OUTLETS_FETCH_ALL_SUCCESS,
  OUTLETS_FETCH_ALL_FAIL,
  OUTLETS_ADD,
  OUTLETS_ADD_SUCCESS,
  OUTLETS_ADD_FAIL,
  OUTLETS_UPDATE,
  OUTLETS_UPDATE_SUCCESS,
  OUTLETS_UPDATE_FAIL,
  OUTLETS_DELETE,
  OUTLETS_DELETE_SUCCESS,
  OUTLETS_DELETE_FAIL,
  OUTLETS_SET_FILTER
} from './constants';
import { createSelector } from 'reselect';
import { buildAddressString } from '../util/address';

const initialState = {
  fetching: false,
  fetched: false,
  outlets: {},
  catFilter: [] // BUTCHER FARM_SHOP SHOP RESTAURANT ONLINE_RETAILER PRODUCER
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case OUTLETS_FETCH_ALL:
      return { ...state, fetching: true };
    case OUTLETS_FETCH_ALL_SUCCESS: {
      const outlets = {};
      action.outlets.forEach(outlet => {
        outlet.addressString = buildAddressString(outlet);
        outlets[outlet.id] = outlet;
        outlets[outlet.id].saved = true;
      });
      // console.log('reducer - FETCH_ALL_SUCCESS', outlets);
      return { ...state, fetching: false, fetched: true, outlets };
    }
    case OUTLETS_FETCH_ALL_FAIL:
      return { ...state, fetching: false };
    case OUTLETS_ADD: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      outlets[action.outlet.id] = action.outlet;
      outlets[action.outlet.id].saving = true;
      return { ...state, outlets };
    }
    case OUTLETS_ADD_SUCCESS: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      delete outlets[action.outlet.id].saving;
      outlets[action.outlet.id].saved = true;
      return { ...state, outlets };
    }
    case OUTLETS_ADD_FAIL: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      delete outlets[action.outlet.id].saving;
      delete outlets[action.outlet.id].saved;
      return { ...state, outlets };
    }
    case OUTLETS_UPDATE: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      outlets[action.outlet.id] = action.outlet;
      outlets[action.outlet.id].saving = true;
      return { ...state, outlets };
    }
    case OUTLETS_UPDATE_SUCCESS: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      outlets[action.outlet.id].saved = true;
      delete outlets[action.outlet.id].saving;
      return { ...state, outlets };
    }
    case OUTLETS_UPDATE_FAIL: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      delete outlets[action.outlet.id].saving;
      return { ...state, outlets };
    }
    case OUTLETS_DELETE: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      delete outlets[action.outlet.id];
      return { ...state, outlets };
    }
    case OUTLETS_DELETE_SUCCESS:
      return state;
    case OUTLETS_DELETE_FAIL: {
      const outlets = JSON.parse(JSON.stringify(state.outlets));
      outlets[action.outlet.id] = action.outlet;
      return { ...state, outlets };
    }
    case OUTLETS_SET_FILTER: {
      const catFilter = [ ...action.catFilter ];
      return { ...state, catFilter };
    }
  }
  return state;
};

const fetching = state => state.whereToBuy.fetching;
const fetched = state => state.whereToBuy.fetched;
const outlets = state => state.whereToBuy.outlets;
const catFilter = state => state.whereToBuy.catFilter;

export const isFetchingOutlets = createSelector(
  fetching, fetching => fetching
);

export const hasFetchedOutlets = createSelector(
  fetched, fetched => fetched
);

export const getSavedOutlets = createSelector(
  outlets, outlets => Object.values(outlets).filter(outlet => outlet.saved)
);

export const getFilteredOutlets = createSelector(
  [getSavedOutlets, catFilter],
  (outlets, categories) => {
    if (categories.length === 0) return outlets; // show all when no filters are selected
    return outlets.filter(
      outlet => categories.includes(outlet.category)
    );
  }
);

export const getGeoJSONOutlets = createSelector(
  getFilteredOutlets, outlets => {
    const features = outlets
      .filter(outlet => outlet.category !== 'PRODUCER')
      .map(outlet => ({
        type: 'Feature',
        geometry: outlet.geometry,
        properties: { ...outlet }
      }));
    return { type: 'FeatureCollection', features };
  }
);

export const getGeoJSONFarms = createSelector(
  getFilteredOutlets, outlets => {
    const features = outlets
      .filter(outlet => outlet.category === 'PRODUCER')
      .map(outlet => ({
        type: 'Feature',
        geometry: outlet.geometry,
        properties: { ...outlet }
      }));
    return { type: 'FeatureCollection', features };
  }
);

export const getOutletsObj = createSelector(
  outlets, outlets => outlets
);

export const getOutletCount = createSelector(
  getFilteredOutlets, outlets => outlets.length
);

export const getCategoryFilters = createSelector(
  catFilter, filter => filter
);

export default reducer;
